const methods = {
  methods: {
    scrollToElement (selector, options = {}) {
      if (selector) {
        selector.scrollIntoView(options)
      }
    },
    isEven (value) {
      return value % 2 === 0
    },
    romanize (num) {
      let roman = ''
      let i
      const lookup = {
        M: 1000,
        CM: 900,
        D: 500,
        CD: 400,
        C: 100,
        XC: 90,
        L: 50,
        XL: 40,
        X: 10,
        IX: 9,
        V: 5,
        IV: 4,
        I: 1
      }
      for (i in lookup) {
        while (num >= lookup[i]) {
          roman += i
          num -= lookup[i]
        }
      }
      return roman
    },
    componentBaseCss (name = '', additionalCssClasses = []) {
      return `bcq-${name}${additionalCssClasses.length ? ' ' + additionalCssClasses.join(' ') : ''}`
    },
    setBgColor (bgColorProp = 'bgColor', bgColorLightnessProp = 'bgColorLightness') {
      const lightness = parseInt(this[bgColorLightnessProp], 10)
      return 'bg-' + this[bgColorProp] + (lightness ? '-' + lightness : '')
    },
    setOutline (bgColorProp = 'bgColor', bgColorLightnessProp = 'bgColorLightness') {
      const lightness = parseInt(this[bgColorLightnessProp], 10)
      return ['border', 'box-border', 'border-' + this[bgColorProp] + (lightness ? '-' + lightness : '')]
    },
    setTextColor (colorProp = 'color', colorLightnessProp = 'colorLightness') {
      const lightness = parseInt(this[colorLightnessProp], 10)
      return 'text-' + this[colorProp] + (lightness ? '-' + lightness : '')
    },
    firstLetterCapital (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    functionName (fn) {
      let ret = fn.toString()
      ret = ret.substr('function '.length)
      ret = ret.substr(0, ret.indexOf('('))
      return ret
    },
    resize () {
      const width = this.viewport().width
      const breakpoints = this.breakpoints
      if (width >= 1920) {
        this.breakpoint = breakpoints[0]
      } else if (width >= 1024 && width < 1920) {
        this.breakpoint = breakpoints[1]
      } else if (width >= 960 && width < 1024) {
        this.breakpoint = breakpoints[2]
      } else if (width >= 480 && width < 960) {
        this.breakpoint = breakpoints[3]
      } else if (width <= 480) {
        this.breakpoint = breakpoints[4]
      }
    },
    viewport () {
      const w = window
      const d = document
      const e = d.documentElement
      const g = d.getElementsByTagName('body')[0]
      const width = w.innerWidth || e.clientWidth || g.clientWidth
      const height = w.innerHeight || e.clientHeight || g.clientHeight
      return {
        width,
        height
      }
    }
  }
}

export default methods



// WEBPACK FOOTER //
// ./src/bcq-ui/mixins/methods.js